import { useMemo } from 'react';
import { useTheme } from 'foundations-theming/utils';
import { DEFAULT_ICON_COLOR_MAP, TRELLIS_DEFAULT_COLORS } from '../../Constants';
const isColor = (color, theme) => {
  return color in theme.color;
};
export const useParsedColorScheme = iconType => {
  const theme = useTheme();
  const {
    backgroundColor,
    iconColor
  } = iconType ? DEFAULT_ICON_COLOR_MAP[iconType] : TRELLIS_DEFAULT_COLORS;
  const parsedBackgroundColor = useMemo(() => {
    if (isColor(backgroundColor, theme)) {
      return theme.color[backgroundColor];
    }
    return backgroundColor;
  }, [backgroundColor, theme]);
  const parsedIconColor = useMemo(() => {
    if (isColor(iconColor, theme)) {
      return theme.color[iconColor];
    }
    return iconColor;
  }, [iconColor, theme]);
  return {
    parsedBackgroundColor,
    parsedIconColor
  };
};